import * as React from 'react';
import { clsx } from 'clsx';

import { HeaderImage } from '../../../../../HeaderImage';
import * as styles from './HeaderStickyField.css';
import { DeleteButton } from '../../../../../DeleteButton';
import { HeaderStickyContent } from '../HeaderStickyContent';

export interface IHeaderStickyFieldProps {
  dragging?: boolean;
  imageUrl: string;
  onClick: () => void;
  onDelete: () => void;
  phone: React.ReactNode;
  price?: string;
  published: boolean;
  title: string;
}

const HeaderStickyFieldComponent: React.FC<IHeaderStickyFieldProps> = ({
  dragging,
  imageUrl,
  onClick,
  onDelete,
  phone,
  price,
  published,
  title,
}) => {
  return (
    <div className={clsx(styles['field'], dragging && styles['field--dragging'])} onClick={onClick}>
      <div className={clsx(styles['image'], !published && styles['image--unpublished'])}>
        <HeaderImage url={imageUrl} alt={title} type={'xs'} />
      </div>
      <HeaderStickyContent published={published} title={title} price={price} phone={phone} />
      <div className={styles['delete']}>
        <DeleteButton type={'xs'} onClick={onDelete} />
      </div>
    </div>
  );
};

export const HeaderStickyField = React.memo(HeaderStickyFieldComponent);
